import { useTitleWhenTruncated } from '../../cdl/ComboBox/hooks/useTitleWhenTruncated';
import { Text } from '../../cdl/Text/Text';

interface DemandProductNameProps {
    name: string;
}

export const DemandProductName = ({ name }: DemandProductNameProps) => {
    const { ref, title } = useTitleWhenTruncated<HTMLSpanElement>(name);

    return (
        <Text ref={ref} title={title} variant="small" color="foreground.muted" truncated>
            {name}
        </Text>
    );
};
